<template>




    <div class="modal is-active"  >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title"> Disable Reason   <span class="tag is-warning">  {{IDLABSelected.idlab}}</span> </p>
                <button class="delete" aria-label="close"   @click="closeBtn" ></button>
            </header>

            <section class="modal-card-body">
                <b-field grouped>
                    <b-field label = "Reason is ..."
                             :type="{ 'is-danger': hasError }"
                             :message="{ 'please select ': hasError}">
                        <b-select placeholder="Select a name"  v-model="disableReasonSelected">
                            <option
                                    v-for="disablereason in listofdisablereason"
                                    :value="disablereason.id"
                                    :key="disablereason.id">
                                {{ disablereason.name }}
                            </option>
                        </b-select>
                    </b-field>
                </b-field>
            </section>
            <footer class="modal-card-foot">
                <!--                <button class="button is-danger"   @click="closeBtn" >Cancel</button>-->
                <b-button type="is-danger"
                          icon-right="close"
                          @click="closeBtn" >Cancel</b-button>
                <b-button type="is-success"
                          icon-right="cloud-upload"
                          @click="saveBtn" >Save to disable</b-button>
            </footer>
        </div>
     </div>

</template>

<script>
    /* eslint-disable */
    import axios from "axios"
    import { getBaseURLforBackEnd  , getConfigAxios  }  from '@/utils.js'
    import { mapState } from "vuex";
    export default {
        name: "DisableDlg",
        mounted() {
            this.initData()
        },
        computed:{
            ...mapState({
                IDLABSelected: state => state.lab_target.lab_selected,
                access_token: state => state.master_data.access_token,
            })
        },
        methods: {
            saveBtn(){
                if (this.disableReasonSelected === null){
                    this.hasError = true
                }else {
                    // console.log('gonna be ok')

                    const vm = this
                    const datTo =  {
                                        "idlab" : this.IDLABSelected.idlab ,
                                        "id_disable_lab" : this.disableReasonSelected
                                   }
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`               
                    axios.post(`${getBaseURLforBackEnd()}/api/disable_labnonautomate`,datTo,getConfigAxios())
                        .then(res=>{
                            if (res.status === 200) {
                                vm.$emit('closeWithChange')
                            }
                        })
                        .catch(err=>{
                            if (err.response && err.response.status === 401) {
                                vm.$router.push('/login')
                            }
                        })



                   

                }
            },
            closeBtn() {
                this.$emit('close')
            },
            initData() {
                /* eslint-disable */

                const vm = this
                const datTo = {
                    "admin": false
                }
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/listofdisablereason`, datTo, getConfigAxios())
                    .then((res) => {
                        vm.listofdisablereason = res.data

                    })
                    .catch(err => {
                        vm.isFullScreenLoading = false
                        vm.$buefy.dialog.alert({
                            title: 'Error',
                            message: `Error  from ${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    })

            }
        },
        data() {
            return {
                listofdisablereason: [],
                isComponentModalActive: false,
                disableReasonSelected: null,
                hasError : false
            }
        },
        watch : {
            disableReasonSelected : function (val) {
                   if(val !== null){
                       this.hasError = false
                   }
            }
        }

    }
</script>

<style scoped>

</style>